import styled from 'styled-components'

export default styled.div`
  width: 100%;
  display: block;
  ${({ monospace }) => monospace && 'font-family: "Lucida Console", Courier, monospace;'}
`
